// extracted by mini-css-extract-plugin
export var container = "style-module--container--ZwQuj";
export var tabs = "style-module--tabs--lnRVY";
export var tabTitle = "style-module--tabTitle--wKzMx";
export var titleBorder = "style-module--titleBorder--ycdlp";
export var titleText = "style-module--titleText--HZ6tM";
export var active = "style-module--active--y8E8A";
export var tabsContent = "style-module--tabsContent--2Bf7s";